module.exports = {
    apiKey: "AIzaSyBEas9tYoPCQ3wDs0kmtTCSM1Ygw-4NnAM",
    authDomain: "lista-de-tareas-f3bac.firebaseapp.com",
    projectId: "lista-de-tareas-f3bac",
    storageBucket: "lista-de-tareas-f3bac.appspot.com",
    messagingSenderId: "581248604618",
    appId: "1:581248604618:web:6afd3bc5971a0356741733",
    measurementId: "G-Z96CTV5JLG"
};